"use strict";

var _slicedToArray = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Parses the color from a string.
 * @param trimmedValue The value with the color.
 * @throws {SyntaxError} The color is invalid.
 * @returns The parsed color.
 */

var parseValue = function parseValue(value) {
  var trimmedValue = value.trim();

  if (!/#[\da-f]{6}|#[\da-f]{8}|-{0,1}[\d]+/i.test(trimmedValue)) {
    throw new SyntaxError("The color is invalid: ".concat(trimmedValue));
  }

  var hex;

  if (trimmedValue.startsWith("#")) {
    hex = trimmedValue.slice(1).padStart(8, "f");
  } else {
    var unfoledValue = Number.parseInt(trimmedValue, 10) >>> 0;
    hex = unfoledValue.toString(16).padStart(8, "0");
  }

  return {
    alpha: Number.parseInt(hex.slice(0, 2), 16),
    red: Number.parseInt(hex.slice(2, 4), 16),
    green: Number.parseInt(hex.slice(4, 6), 16),
    blue: Number.parseInt(hex.slice(6, 8), 16)
  };
};
/**
 * Parses the .attheme contents.
 * @param contents The .attheme contents to parse.
 * @returns The parsed contents.
 */


var parseContents = function parseContents(contents) {
  var result = {
    variables: new Map()
  };
  var lines = contents.split("\n");
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var rawLine = _step.value;

      if ("wallpaper" in result) {
        if (rawLine.startsWith("WPE")) {
          // Cutting off the last \n
          result.wallpaper = result.wallpaper.slice(0, -1);
          break;
        }

        result.wallpaper += "".concat(rawLine, "\n");
        continue;
      }

      if (rawLine.startsWith("WPS")) {
        result.wallpaper = "";
        continue;
      }

      var _rawLine$split = rawLine.split("//"),
          _rawLine$split2 = _slicedToArray(_rawLine$split, 1),
          noCommentsLine = _rawLine$split2[0];

      var assignOperatorIndex = noCommentsLine.indexOf("=");

      if (assignOperatorIndex !== -1) {
        var variable = noCommentsLine.slice(0, assignOperatorIndex);

        if (variable === "wallpaperFileOffset") {
          // wallpaperFileOffset is just a leaked internal integer value.
          // Skipping it.
          continue;
        }

        var rawValue = noCommentsLine.slice(assignOperatorIndex + 1);

        try {
          var value = parseValue(rawValue);
          result.variables.set(variable, value);
        } catch (_a) {// Ignore, just like Telegram does
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};

exports["default"] = parseContents;